import AsoHeader from '../../../../components/Aso/Header';
import AsoValidarSenha from '../../../../components/Aso/Register/AsoValidarSenha';

const AsoRegistroValidarSenha: React.FC = () => {

  return (
    <div>
      <AsoHeader />
      <AsoValidarSenha />
    </div>
  );
}

export default AsoRegistroValidarSenha